export interface OperacaoContent {
	title: string;
	daysOfOperation: string;
	minutesInYear: string;
	hoursWorked: string;
	footballMatches: {
		title: string;
		equationSuffix: string;
		result: string;
		note: string;
	};
	tripsToJapan: {
		title: string;
		equationSuffix: string;
		result: string;
		note: string;
	};
}

export const operacaoContent: OperacaoContent = {
	title: "TEMPO DE OPERAÇÃO",
	daysOfOperation: "Dias de Operação",
	minutesInYear: "Minutos no Ano",
	hoursWorked: "Horas Trabalhadas",
	footballMatches: {
		title: "Partidas de Futebol",
		equationSuffix: "minutos =",
		result: "Partidas completas de 90 minutos",
		note: "⚽ Daria para assistir 16 partidas por dia durante o ano inteiro!",
	},
	tripsToJapan: {
		title: "Viagens para o Japão",
		equationSuffix: "horas =",
		result: "Viagens SP-Tóquio (24h cada)",
		note: "✈️ 1 viagem completa por dia, ida e volta ao Japão!",
	},
};
